import { TaskTypeStatus, type LeadType, type ObjectType, type TaskTypeStyleType, type UserType } from '@econtractor/types';
import vconst from 'utils/helpers/structs/vconst';

/** У фільтрі задач: усі статуси заявок, крім Погоджено і Відмова */
export const TASK_FILTER_LEAD_STATUSES = [
    vconst.leadNew,
    vconst.leadInWoork,
    vconst.leadNeedOffer,
    vconst.leadNeedsAttention,
    vconst.leadOffer,
];

/** У фільтрі задач: усі статуси об'єктів, крім Завершений і Відмінений */
export const TASK_FILTER_OBJECT_STATUSES = [
    vconst.objectPanding,
    vconst.objectInWork,
    vconst.objectFinishedTeam,
];

export const TASK_FILTER_STATUSES = [
    TaskTypeStatus.NEW,
    TaskTypeStatus.INWORK,
    TaskTypeStatus.COMPLETED,
    TaskTypeStatus.ACCEPTED,
    TaskTypeStatus.CANCELLED,
] as const;

export interface FilterOption {
    value: number;
    label: string;
    kind: 'type' | 'status' | 'category';
    icon?: string | null;
    colors?: TaskTypeStyleType | null;
}

export type TaskFilterProps = {
    /** Статуси, які не показувати у фільтрі */
    excludeStatuses?: number[];
    /** Показати фільтр виконавця (UserSelected, одиночний вибір) */
    showExecutorFilter?: boolean;
    /** Показати фільтр контролера (UserSelected, одиночний вибір) */
    showControllerFilter?: boolean;
    /** Початковий виконавець для UI (snapshot з localStorage) */
    initialExecutorUser?: UserType | null;
    /** Початковий контролер для UI (snapshot з localStorage) */
    initialControllerUser?: UserType | null;
    initialLead?: LeadType | null;
    initialObject?: ObjectType | null;
    onExecutorUserChange?: (user: UserType | null) => void;
    onControllerUserChange?: (user: UserType | null) => void;
    onLeadChange?: (lead: LeadType | null) => void;
    onObjectChange?: (object: ObjectType | null) => void;
};
